import React, { useState } from 'react';

import { Link } from 'react-router-dom';

import { Dropdown, Badge, Avatar, Button } from 'antd';
import { CameraOutlined } from '@ant-design/icons';
import notifi from 'static/img/header/notifi_newdesign.png';

import { FormattedMessage, useIntl } from 'react-intl';
import * as types from 'app/actions/action_types';
import store from 'app/store';
import moment from 'moment';
import parse from 'html-react-parser';
import { friendshipAPI } from '../../../API/friendship.api';

import userAPI from '../../../API/user.service.api';
import { clubAPI } from '../../../API/club.api';
import { academyAPI } from '../../../API/academy.api';

import { openNotificationWithIcon } from '../../Utility/notificationMessage';

import { getIdFromUrl } from '../../Utility/getIdFromUrl';

import NotificationList from '../List/notification/notification';

const ACCEPT = 'accept';
// const DECLINE = 'decline';

const NotificationComponent = (props) => {
  const { data = [], getNotificationData } = props;
  const [show, setShow] = useState();
  const intl = useIntl();

  const getCount = () => {
    let count = 0;
    data.forEach((item) => {
      if (item.entity) {
        if (
          (item && item.entity && !item.entity.viewed) ||
          (item.entity.viewed && item.entity.viewed === '0')
        ) {
          count++;
        }
      }
    });
    return `${count}`;
  };

  const errHandler = (err) => openNotificationWithIcon('error', err.message);

  const refresUserData = () => {
    const id = getIdFromUrl(props.router.location.pathname);
    userAPI.getHistoryById(id).then((res) => {
      const { code } = res;
      if (code === 200) {
        store.dispatch({
          type: types.SET_USER_HISTORY_DATA,
          payload: res,
        });
      }
    });
  };

  const acceptAction = (id, type) => {
    friendshipAPI
      .request(id, type)
      .then(() => {
        openNotificationWithIcon(
          'success',
          intl.formatMessage({
            id: 'Friendship accepted',
            defaultMessage: 'Friendship accepted',
          })
        );

        getNotificationData();

        if (props.router.location.pathname.indexOf('profile') !== -1) {
          refresUserData();
        }
      })
      .catch(errHandler);
  };

  const rejectAction = (id, type) => {
    friendshipAPI
      .request(id, type)
      .then(() => {
        openNotificationWithIcon(
          'success',
          intl.formatMessage({
            id: 'Friendship rejected',
            defaultMessage: 'Friendship rejected',
          })
        );

        getNotificationData();
      })
      .catch(errHandler);
  };

  const acceptJoinAction = (id, type) => {
    clubAPI
      .requestClub(id, type)
      .then(() => {
        if (type === ACCEPT) {
          openNotificationWithIcon(
            'success',
            intl.formatMessage({
              id: 'Invitation accepted',
              defaultMessage: 'Invitation accepted',
            })
          );
          if (props.router.location.pathname.indexOf('profile') !== -1) {
            refresUserData();
          }
        } else {
          openNotificationWithIcon(
            'success',
            intl.formatMessage({
              id: 'Invitation rejected',
              defaultMessage: 'Invitation rejected',
            })
          );
        }

        getNotificationData();
      })
      .catch(errHandler);
  };

  const rideWithFriendAction = (feuser_id, frid, type) => {
    friendshipAPI
      .driveWithFriends(feuser_id, frid, type)
      .then(() => {
        if (type === ACCEPT) {
          openNotificationWithIcon(
            'success',
            intl.formatMessage({
              id: 'Invitation accepted',
              defaultMessage: 'Invitation accepted',
            })
          );
        } else {
          openNotificationWithIcon(
            'success',
            intl.formatMessage({
              id: 'Invitation rejected',
              defaultMessage: 'Invitation rejected',
            })
          );
        }

        getNotificationData();
      })
      .catch(errHandler);
  };

  const viewNotification = (item) => {
    academyAPI
      .viewNotification(item)
      .then((res) => {
        const { code } = res;
        if (code === 200) {
          getNotificationData();
        }
      })
      .catch(errHandler);
  };

  const notificationItem = (item, i, list = false) => {
    if (!item && !item.entity) {
      return null;
    }

    if (item.entity === null || item.entity === undefined) {
      return null;
    }

    const {
      id,
      url,
      title = '',
      manageteam,
      name = '',
      managerelations,
      bikerbed,
      logo,
      tour_name = '',
      tour_url,
      user_name = '',
      user_url,
      userreftour,
      date,
      feuser_id,
      cerId = '',
      listId = '',
      viewed = '0',
    } = item.entity;

    if (viewed === '1' && !list) return null;

    switch (item.type) {
      case 'new_clubmember':
        return (
          <div key={id + i} className="notifiItem" style={{ minHeight: 90 }}>
            <div className="avatar">
              <Avatar
                src={process.env.BACKEND_URL + logo}
                icon={<CameraOutlined />}
                size={80}
              />
            </div>
            <div className="body">
              <div className="header">
                <FormattedMessage
                  id="There are user(s) who applied for membership of the bike club"
                  defaultMessage="There are user(s) who applied for membership of the bike club"
                />
              </div>
              <Link to={url} className="name">
                {title}
              </Link>
              <Link to={manageteam} className="manage">
                <FormattedMessage
                  id="Manage team"
                  defaultMessage="Manage team"
                />
              </Link>
            </div>
          </div>
        );
      case 'new_friend':
        return (
          <div key={id} className="notifiItem" style={{ minHeight: 90 }}>
            <div
              style={{ display: 'flex', alignItems: 'center' }}
              className="avatar"
            >
              <Avatar
                src={process.env.BACKEND_URL + logo}
                icon={<CameraOutlined />}
                size={80}
              />
            </div>
            <div className="body feuser">
              <div className="header feuser">
                <span>
                  <Link to={url} className="name">
                    {parse(name)}
                  </Link>
                </span>
                <FormattedMessage
                  id="has sent you a friendship request"
                  defaultMessage="has sent you a friendship request"
                />
              </div>
              <span>
                <a
                  className="manage accept"
                  onClick={() => acceptAction(id, 'accept')}
                  aria-hidden
                >
                  <FormattedMessage id="Accept" defaultMessage="Accept" />
                </a>
                /
                <a
                  className="manage reject"
                  onClick={() => rejectAction(id, 'decline')}
                  aria-hidden
                >
                  <FormattedMessage id="Reject" defaultMessage="Reject" />
                </a>
              </span>
            </div>
          </div>
        );
      case 'new_relation_request':
        return (
          <div key={id} className="notifiItem" style={{ minHeight: 90 }}>
            <div
              style={{ display: 'flex', alignItems: 'center' }}
              className="avatar"
            >
              <Avatar
                src={process.env.BACKEND_URL + logo}
                icon={<CameraOutlined />}
                size={80}
              />
            </div>
            <div className="body feuser">
              <div className="header feuser">
                <FormattedMessage id="Bike club" defaultMessage="Bike club" />
                <span>
                  <Link to={url} className="name" style={{ marginLeft: 3 }}>
                    {parse(title)}
                  </Link>
                </span>
                <FormattedMessage
                  id="has a relation request"
                  defaultMessage="has a relation request"
                />
              </div>
              <Link to={managerelations} className="manage">
                <FormattedMessage
                  id="Click to manage the bike club relation"
                  defaultMessage="Click to manage the bike club relation"
                />
              </Link>
            </div>
          </div>
        );
      case 'invite_to_club':
        return (
          <div key={id} className="notifiItem" style={{ minHeight: 90 }}>
            <div
              style={{ display: 'flex', alignItems: 'center' }}
              className="avatar"
            >
              <Avatar
                src={process.env.BACKEND_URL + logo}
                icon={<CameraOutlined />}
                size={80}
              />
            </div>
            <div className="body feuser">
              <div className="header feuser">
                <FormattedMessage
                  id="You've got an invitation from"
                  defaultMessage="You've got an invitation from"
                />
                {/* <FormattedMessage id="You got an invitation" defaultMessage="You got an invitation" /> */}
                <span style={{ marginLeft: 3 }}>
                  <Link to={url} className="name">
                    {parse(title)}
                  </Link>
                </span>
              </div>
              <span>
                <a
                  className="manage accept"
                  onClick={() => acceptJoinAction(id, 'accept')}
                  aria-hidden
                >
                  <FormattedMessage id="Accept" defaultMessage="Accept" />
                </a>
                /
                <a
                  className="manage reject"
                  onClick={() => acceptJoinAction(id, 'decline')}
                  aria-hidden
                >
                  <FormattedMessage id="Reject" defaultMessage="Reject" />
                </a>
              </span>
            </div>
          </div>
        );
      case 'drive_tour':
        return (
          <div
            key={userreftour}
            className="notifiItem"
            style={{ minHeight: 90 }}
          >
            <div
              style={{ display: 'flex', alignItems: 'center' }}
              className="avatar"
            >
              <Avatar
                src={process.env.BACKEND_URL + logo}
                icon={<CameraOutlined />}
                size={80}
              />
            </div>
            <div className="body feuser">
              <div className="header feuser">
                <span style={{ marginRight: 3 }}>
                  <Link to={user_url} className="name">
                    {parse(user_name)}
                  </Link>
                </span>
                <FormattedMessage
                  id="invited you for a motorcycle ride"
                  defaultMessage="invited you for a motorcycle ride"
                />
                <span style={{ marginLeft: 3, marginRight: 3 }}>
                  <Link to={tour_url} className="name">
                    {parse(tour_name)}
                  </Link>
                </span>
                <FormattedMessage id="on" defaultMessage="on" />
                <span style={{ marginLeft: 3 }}>
                  {moment(date).format('LLL')}
                </span>
              </div>
              <span>
                <a
                  className="manage accept"
                  onClick={() => {
                    rideWithFriendAction(feuser_id, userreftour, 'accept');
                  }}
                  aria-hidden
                >
                  <FormattedMessage id="Accept" defaultMessage="Accept" />
                </a>
                /
                <a
                  className="manage reject"
                  onClick={() => {
                    rideWithFriendAction(feuser_id, userreftour, 'decline');
                  }}
                  aria-hidden
                >
                  <FormattedMessage id="Reject" defaultMessage="Reject" />
                </a>
              </span>
            </div>
          </div>
        );
      case 'academy_share_certificate':
        return (
          <div key={i} className="notifiItem" style={{ minHeight: 90 }}>
            <div
              style={{ display: 'flex', alignItems: 'center' }}
              className="avatar"
            >
              <Avatar
                src={process.env.BACKEND_URL + logo}
                icon={<CameraOutlined />}
                size={80}
              />
            </div>
            <div className="body feuser">
              <div className="header feuser">
                <span style={{ marginRight: 3 }}>
                  <Link to={url} className="name">
                    {parse(name)}
                  </Link>
                </span>
                <FormattedMessage
                  id="completed the"
                  defaultMessage="completed the"
                />
                <span style={{ marginLeft: 3, marginRight: 3 }}>
                  <Link
                    to={`${props.router.location.pathname}?scope=academy&list=${listId}`}
                    className="name"
                  >
                    {title}
                  </Link>
                </span>
                <FormattedMessage id="course in" defaultMessage="course in" />
                <span style={{ marginLeft: 3, marginRight: 3 }}>
                  <Link
                    to={`${props.router.location.pathname}?scope=academy`}
                    className="name"
                  >
                    <FormattedMessage
                      id="Toustart Academy"
                      defaultMessage="Toustart Academy"
                    />
                  </Link>
                </span>
                <FormattedMessage
                  id="and received a"
                  defaultMessage="and received a"
                />
                <span style={{ marginLeft: 3, marginRight: 3 }}>
                  <a
                    href={`${process.env.SERVER_URL}/uploaded_content/academy/pdf/${cerId}.pdf`}
                    className="name"
                  >
                    <FormattedMessage
                      id="certificate"
                      defaultMessage="certificate"
                    />
                  </a>
                  .
                </span>
                {!list && (
                  <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <a
                      href="#"
                      className="name"
                      onClick={() => viewNotification(item)}
                    >
                      <FormattedMessage id="Ok" defaultMessage="Ok" />
                    </a>
                  </div>
                )}
              </div>
            </div>
          </div>
        );
      case 'academy_change_add_video':
        return (
          <div key={i} className="notifiItem" style={{ minHeight: 90 }}>
            <div
              style={{ display: 'flex', alignItems: 'center' }}
              className="avatar"
            >
              <Avatar
                src={process.env.BACKEND_URL + logo}
                icon={<CameraOutlined />}
                size={80}
              />
            </div>
            <div className="body feuser">
              <div className="header feuser">
                <FormattedMessage
                  id="Video has been added or changed in Tourstart Academy"
                  defaultMessage="Video has been added or changed in Tourstart Academy"
                />
                <span style={{ marginLeft: 3, marginRight: 3 }}>
                  {`"
                  ${(
                    <Link
                      to={`${props.router.location.pathname}?scope=academy&list=${listId}`}
                      className="name"
                    >
                      {title}
                    </Link>
                  )}
                  ".`}
                </span>
                <FormattedMessage
                  id="You are encuraged to watch this. Note that your certificate remains."
                  defaultMessage="You are encuraged to watch this. Note that your certificate remains."
                />
                {!list && (
                  <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <span
                      className="name"
                      onClick={() => viewNotification(item)}
                      aria-hidden
                    >
                      Ok
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>
        );
      case 'academy_share_finished_course':
        return (
          <div key={i} className="notifiItem" style={{ minHeight: 90 }}>
            <div
              style={{ display: 'flex', alignItems: 'center' }}
              className="avatar"
            >
              <Avatar
                src={process.env.BACKEND_URL + logo}
                icon={<CameraOutlined />}
                size={80}
              />
            </div>
            <div className="body feuser">
              <div className="header feuser">
                <span style={{ marginRight: 3 }}>
                  <Link to={url} className="name">
                    {parse(name)}
                  </Link>
                </span>
                <FormattedMessage
                  id="has passet the training"
                  defaultMessage="has passet the training"
                />
                <span style={{ marginLeft: 3, marginRight: 3 }}>
                  {`"
                  ${(
                    <Link
                      to={`${props.router.location.pathname}?scope=academy`}
                      className="name"
                    >
                      {title}
                    </Link>
                  )}
                  "`}
                </span>
                <FormattedMessage
                  id="in Tourstart Academy and is now a professional tour planner."
                  defaultMessage="in Tourstart Academy and is now a professional tour planner."
                />
                {!list && (
                  <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <span
                      className="name"
                      onClick={() => viewNotification(item)}
                      aria-hidden
                    >
                      Ok
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  const menu = (
    <>
      <div className="menu_notification">
        <div className="menu_notification_list">
          {data.length > 0 ? (
            data.map((item, i) => notificationItem(item, i))
          ) : (
            <div className="notifiEmpty">
              <FormattedMessage
                id="Notification not found"
                defaultMessage="Notification not found"
              />
            </div>
          )}
        </div>
        <div className="show_all_btn">
          <Button onClick={() => setShow(true)}>
            <span>
              <FormattedMessage
                id="Show all notification"
                defaultMessage="Show all notification"
              />
            </span>
          </Button>
        </div>
      </div>
    </>
  );

  return (
    <div>
      <Dropdown
        overlayStyle={show ? { display: 'none' } : {}}
        overlay={menu}
        trigger={['click']}
        getPopupContainer={(trigger) => trigger.parentNode}
        placement="bottom"
      >
        <Badge
          count={getCount()}
          offset={[-36, 10]}
          className="mainMenuUserLoginBadge"
        >
          <img src={notifi} alt="notifi" />
          <span className="sub_title">
            <FormattedMessage id="Notification" defaultMessage="Notification" />
          </span>
        </Badge>
      </Dropdown>
      {/* </Tooltip> */}
      {show ? (
        <NotificationList
          notificationItem={notificationItem}
          dataNotifi={data}
          setShow={setShow}
          closeFunc={() => setShow(false)}
        />
      ) : null}
    </div>
  );
};

export default NotificationComponent;
